var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"input-checkbox",class:[{'input-checkbox--switch': _vm.isSwitch}]},[_c('input',{attrs:{"id":_vm.inputId,"type":"checkbox","name":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_c('label',{attrs:{"for":_vm.inputId}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }